import { render, staticRenderFns } from "./ImportPCG.vue?vue&type=template&id=4ae2134d&scoped=true&"
import script from "./ImportPCG.vue?vue&type=script&lang=js&"
export * from "./ImportPCG.vue?vue&type=script&lang=js&"
import style0 from "./ImportPCG.vue?vue&type=style&index=0&id=4ae2134d&scoped=true&lang=scss&"
import style1 from "./ImportPCG.vue?vue&type=style&index=1&id=4ae2134d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2134d",
  null
  
)

export default component.exports